import { paperClasses } from "@mui/material/Paper";
export const Card = {
    MuiCard: {
        defaultProps: {
            color: "primary"
        },
        styleOverrides: {
            root: {
                /**
                 * By default, increasing the elevation overlays a slight tint to indicate that the
                 * component is elevated. If you don't want this behavior, you can disable it by
                 * setting the backgroundImage for Paper to none.
                 */ [`&.${paperClasses.root}`]: {
                    backgroundImage: "none"
                }
            }
        }
    },
    MuiCardHeader: {
        defaultProps: {
            titleTypographyProps: {
                variant: "h2",
                color: "primary.dark"
            }
        }
    }
};

//# sourceMappingURL=Card.js.map